import React from 'react';
import styles from '../../../styles/UserManagement.module.css';
import tableStyles from '../../../styles/Table.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';
import SkeletonLoader from '../../UI/SkeletonLoader';
import EmptyState from '../../UI/EmptyState';

interface PendingRequestsTableProps {
    loading: boolean;
    requests: any[];
    onApprove: (id: string) => void;
    onReject: (id: string) => void;
    actionLoadingId?: string | null;
    actionType?: 'approve' | 'reject' | null;
}

const PendingRequestsTable: React.FC<PendingRequestsTableProps> = ({
    loading,
    requests,
    onApprove,
    onReject,
    actionLoadingId,
    actionType
}) => {
    const formatDesignation = (designation: string) => {
        if (!designation) return '';
        return designation
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    return (
        <div className={styles.tableContainer}>
            {loading ? (
                <SkeletonLoader count={5} variant="table" />
            ) : requests.length === 0 ? (
                <EmptyState
                    title="No Pending Requests"
                    description="There are no faculty enrollment requests pending approval."
                />
            ) : (
                <div className={styles.desktopTableContainer}>
                    <table className={tableStyles.Table}>
                        <thead>
                            <tr>
                                <th>Faculty Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Department</th>
                                <th>Designation</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.map((req) => {
                                const isActionLoading = actionLoadingId === req.id;
                                return (
                                    <tr key={req.id}>
                                        <td>
                                            <div className={styles.userName}>{req.faculty_name}</div>
                                        </td>
                                        <td>{req.email}</td>
                                        <td>{req.phone_number}</td>
                                        <td>{req.department}</td>
                                        <td>{formatDesignation(req.designation)}</td>
                                        <td>
                                            <span className={`${styles.statusBadge} ${styles.statusActive}`}>
                                                {req.status}
                                            </span>
                                        </td>
                                        <td>
                                            <div className={tableStyles.tableActions}>
                                                <button
                                                    className={`${buttonStyles.btn} ${buttonStyles.btnPrimary} ${styles.compactBtn} ${styles.tooltipBtn}`}
                                                    onClick={() => onApprove(req.id)}
                                                    data-tooltip="Approve"
                                                    disabled={isActionLoading}
                                                    style={{ minWidth: isActionLoading && actionType === 'approve' ? '80px' : 'auto' }}
                                                >
                                                    {isActionLoading && actionType === 'approve' ? (
                                                        <>
                                                            <svg className={buttonStyles.spinner} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                                                            </svg>
                                                        </>
                                                    ) : (
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <polyline points="20 6 9 17 4 12"></polyline>
                                                        </svg>
                                                    )}
                                                </button>
                                                <button
                                                    className={`${buttonStyles.btn} ${buttonStyles.btnDanger} ${styles.compactBtn} ${styles.tooltipBtn}`}
                                                    onClick={() => onReject(req.id)}
                                                    data-tooltip="Reject"
                                                    disabled={isActionLoading}
                                                    style={{ minWidth: isActionLoading && actionType === 'reject' ? '80px' : 'auto' }}
                                                >
                                                    {isActionLoading && actionType === 'reject' ? (
                                                        <>
                                                            <svg className={buttonStyles.spinner} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                                                            </svg>
                                                        </>
                                                    ) : (
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                                        </svg>
                                                    )}
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default PendingRequestsTable;
